export const ROUTE_PATH = '/documents';

export const FEATURE_NAME = 'documentsPage';
